import { render, staticRenderFns } from "./product_price.vue?vue&type=template&id=c0680df6&scoped=true&"
import script from "./product_price.vue?vue&type=script&lang=js&"
export * from "./product_price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0680df6",
  null
  
)

export default component.exports